import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const SearchIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 23, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 23) / 23}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3234 0C4.63427 0 0 4.63269 0 10.3199C0 16.007 4.63427 20.6487 10.3234 20.6487C12.7533 20.6487 14.9882 19.7974 16.7544 18.384L21.0545 22.6803C21.2715 22.8883 21.5614 23.003 21.8619 22.9999C22.1625 22.9969 22.45 22.8763 22.6627 22.6639C22.8754 22.4516 22.9964 22.1645 22.9999 21.864C23.0034 21.5635 22.8891 21.2736 22.6813 21.0564L18.3813 16.7578C19.7963 14.9894 20.6489 12.7518 20.6489 10.3199C20.6489 4.63269 16.0124 0 10.3234 0ZM10.3234 2.29383C14.7723 2.29383 18.3521 5.87238 18.3521 10.3199C18.3521 14.7673 14.7723 18.3549 10.3234 18.3549C5.87435 18.3549 2.29458 14.7673 2.29458 10.3199C2.29458 5.87238 5.87435 2.29383 10.3234 2.29383Z"
        fill="currentColor"
      />
    </svg>
  )
})

SearchIcon.displayName = 'SearchIcon'
